{
  "abi": [
    {
      "type": "constructor",
      "inputs": [
        {
          "name": "_superPaymaster",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "_registry",
          "type": "address",
          "internalType": "address"
        }
      ],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "APNTS_PRICE_DELTA_BPS",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "APNTS_PRICE_MAX",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "APNTS_PRICE_MIN",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "DEFAULT_SAFETY_FACTOR",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "MAX_INDUSTRY_SCALE_USD",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "MIN_SUGGESTED_AMOUNT",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "REGISTRY",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "SUPERPAYMASTER",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "aPNTsPriceUSD",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "capRatioBps",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "uint16",
          "internalType": "uint16"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "categoryRegistered",
      "inputs": [
        {
          "name": "",
          "type": "string",
          "internalType": "string"
        }
      ],
      "outputs": [
        {
          "name": "",
          "type": "bool",
          "internalType": "bool"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "communityToToken",
      "inputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "deployedTokens",
      "inputs": [
        {
          "name": "",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "outputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "deployxPNTsToken",
      "inputs": [
        {
          "name": "name",
          "type": "string",
          "internalType": "string"
        },
        {
          "name": "symbol",
          "type": "string",
          "internalType": "string"
        },
        {
          "name": "communityName",
          "type": "string",
          "internalType": "string"
        },
        {
          "name": "communityENS",
          "type": "string",
          "internalType": "string"
        },
        {
          "name": "exchangeRate",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "paymasterAOA",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [
        {
          "name": "token",
          "type": "address",
          "internalType": "address"
        }
      ],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "getAPNTsPrice",
      "inputs": [],
      "outputs": [
        {
          "name": "price",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "getAllTokens",
      "inputs": [],
      "outputs": [
        {
          "name": "tokens",
          "type": "address[]",
          "internalType": "address[]"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "getDeployedCount",
      "inputs": [],
      "outputs": [
        {
          "name": "count",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "getDepositBreakdown",
      "inputs": [
        {
          "name": "community",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [
        {
          "name": "dailyCost",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "monthlyCost",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "suggestedAmount",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "multiplierUsed",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "safetyFactorUsed",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "getIndustryMultiplier",
      "inputs": [
        {
          "name": "industry",
          "type": "string",
          "internalType": "string"
        }
      ],
      "outputs": [
        {
          "name": "multiplier",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "getPredictionParams",
      "inputs": [
        {
          "name": "community",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [
        {
          "name": "params",
          "type": "tuple",
          "internalType": "struct xPNTsFactory.PredictionParams",
          "components": [
            {
              "name": "avgDailyTx",
              "type": "uint256",
              "internalType": "uint256"
            },
            {
              "name": "avgGasCost",
              "type": "uint256",
              "internalType": "uint256"
            },
            {
              "name": "industryMultiplier",
              "type": "uint256",
              "internalType": "uint256"
            },
            {
              "name": "safetyFactor",
              "type": "uint256",
              "internalType": "uint256"
            }
          ]
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "getTokenAddress",
      "inputs": [
        {
          "name": "community",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [
        {
          "name": "token",
          "type": "address",
          "internalType": "address"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "hasToken",
      "inputs": [
        {
          "name": "community",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [
        {
          "name": "",
          "type": "bool",
          "internalType": "bool"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "implementation",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "industryMultipliers",
      "inputs": [
        {
          "name": "",
          "type": "string",
          "internalType": "string"
        }
      ],
      "outputs": [
        {
          "name": "",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "industryScaleUSD",
      "inputs": [
        {
          "name": "",
          "type": "string",
          "internalType": "string"
        }
      ],
      "outputs": [
        {
          "name": "",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "isXPNTs",
      "inputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [
        {
          "name": "",
          "type": "bool",
          "internalType": "bool"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "owner",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "predictDepositAmount",
      "inputs": [
        {
          "name": "community",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [
        {
          "name": "suggestedAmount",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "predictions",
      "inputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [
        {
          "name": "avgDailyTx",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "avgGasCost",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "industryMultiplier",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "safetyFactor",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "propagateSuperPaymaster",
      "inputs": [
        {
          "name": "start",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "limit",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "renounceOwnership",
      "inputs": [],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "setCapRatioBps",
      "inputs": [
        {
          "name": "bps",
          "type": "uint16",
          "internalType": "uint16"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "setIndustryMultiplier",
      "inputs": [
        {
          "name": "industry",
          "type": "string",
          "internalType": "string"
        },
        {
          "name": "multiplier",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "setIndustryScaleUSD",
      "inputs": [
        {
          "name": "category",
          "type": "string",
          "internalType": "string"
        },
        {
          "name": "scaleUSD",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "setSuperPaymasterAddress",
      "inputs": [
        {
          "name": "_superPaymaster",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "setTokenCategory",
      "inputs": [
        {
          "name": "token",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "category",
          "type": "string",
          "internalType": "string"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "tokenCategory",
      "inputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [
        {
          "name": "",
          "type": "string",
          "internalType": "string"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "transferOwnership",
      "inputs": [
        {
          "name": "newOwner",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "updateAPNTsPrice",
      "inputs": [
        {
          "name": "newPrice",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "updatePrediction",
      "inputs": [
        {
          "name": "avgDailyTx",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "avgGasCost",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "industry",
          "type": "string",
          "internalType": "string"
        },
        {
          "name": "safetyFactor",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "updatePredictionCustom",
      "inputs": [
        {
          "name": "avgDailyTx",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "avgGasCost",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "customMultiplier",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "safetyFactor",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "version",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "string",
          "internalType": "string"
        }
      ],
      "stateMutability": "pure"
    },
    {
      "type": "event",
      "name": "APNTsPriceUpdated",
      "inputs": [
        {
          "name": "oldPrice",
          "type": "uint256",
          "indexed": false,
          "internalType": "uint256"
        },
        {
          "name": "newPrice",
          "type": "uint256",
          "indexed": false,
          "internalType": "uint256"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "CapRatioBpsSet",
      "inputs": [
        {
          "name": "oldBps",
          "type": "uint16",
          "indexed": false,
          "internalType": "uint16"
        },
        {
          "name": "newBps",
          "type": "uint16",
          "indexed": false,
          "internalType": "uint16"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "IndustryMultiplierSet",
      "inputs": [
        {
          "name": "industry",
          "type": "string",
          "indexed": true,
          "internalType": "string"
        },
        {
          "name": "multiplier",
          "type": "uint256",
          "indexed": false,
          "internalType": "uint256"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "IndustryScaleSet",
      "inputs": [
        {
          "name": "category",
          "type": "string",
          "indexed": true,
          "internalType": "string"
        },
        {
          "name": "scaleUSD",
          "type": "uint256",
          "indexed": false,
          "internalType": "uint256"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "OwnershipTransferred",
      "inputs": [
        {
          "name": "previousOwner",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "newOwner",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "PredictionUpdated",
      "inputs": [
        {
          "name": "community",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "suggestedAmount",
          "type": "uint256",
          "indexed": false,
          "internalType": "uint256"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "SuperPaymasterAddressUpdated",
      "inputs": [
        {
          "name": "oldAddr",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "newAddr",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "SuperPaymasterPropagated",
      "inputs": [
        {
          "name": "token",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "newSP",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "SuperPaymasterPropagationFailed",
      "inputs": [
        {
          "name": "token",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "newSP",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "TokenCategorySet",
      "inputs": [
        {
          "name": "token",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "category",
          "type": "string",
          "indexed": false,
          "internalType": "string"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "xPNTsTokenDeployed",
      "inputs": [
        {
          "name": "community",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "tokenAddress",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "name",
          "type": "string",
          "indexed": false,
          "internalType": "string"
        },
        {
          "name": "symbol",
          "type": "string",
          "indexed": false,
          "internalType": "string"
        }
      ],
      "anonymous": false
    },
    {
      "type": "error",
      "name": "AlreadyDeployed",
      "inputs": [
        {
          "name": "community",
          "type": "address",
          "internalType": "address"
        }
      ]
    },
    {
      "type": "error",
      "name": "CallerNotCommunity",
      "inputs": []
    },
    {
      "type": "error",
      "name": "CategoryNotSeeded",
      "inputs": []
    },
    {
      "type": "error",
      "name": "ERC1167FailedCreateClone",
      "inputs": []
    },
    {
      "type": "error",
      "name": "InvalidAddress",
      "inputs": [
        {
          "name": "addr",
          "type": "address",
          "internalType": "address"
        }
      ]
    },
    {
      "type": "error",
      "name": "InvalidCapRatio",
      "inputs": []
    },
    {
      "type": "error",
      "name": "InvalidMultiplier",
      "inputs": []
    },
    {
      "type": "error",
      "name": "InvalidParameters",
      "inputs": []
    },
    {
      "type": "error",
      "name": "InvalidPrice",
      "inputs": []
    },
    {
      "type": "error",
      "name": "NotFactoryToken",
      "inputs": []
    },
    {
      "type": "error",
      "name": "OwnableInvalidOwner",
      "inputs": [
        {
          "name": "owner",
          "type": "address",
          "internalType": "address"
        }
      ]
    },
    {
      "type": "error",
      "name": "OwnableUnauthorizedAccount",
      "inputs": [
        {
          "name": "account",
          "type": "address",
          "internalType": "address"
        }
      ]
    }
  ]
}